import { NigmaMessage } from '@/model/Message'
import { InjectionKey } from 'vue';
import { createStore, Store } from 'vuex'

export interface State {
  messageHistory: NigmaMessage[],
  sessionId: string,
  showCustomKeyboard: boolean,
  composerHeight: number,
  fastMode: boolean,
  font: string
}

export const key: InjectionKey<Store<State>> = Symbol();


export const ADD_MESSAGE = "ADD_MESSAGE";
export const SEND_MESSAGE_REQ = "SEND_MESSAGE_REQ";
export const SEND_MESSAGE_RES = "SEND_MESSAGE_RES";
export const SEND_MESSAGE_ERR = "SEND_MESSAGE_ERR";
export const CREATE_SESSION_REQ = "CREATE_SESSION_REQ";
export const CREATE_SESSION_RES = "CREATE_SESSION_RES";
export const CREATE_SESSION_ERR = "CREATE_SESSION_ERR";
export const TOGGLE_CUSTOM_KEYBOARD = "TOGGLE_CUSTOM_KEYBOARD";
export const UPDATE_COMPOSER_HEIGHT = "UPDATE_COMPOSER_HEIGHT";
export const RESET_MESSAGES = "RESET_MESSAGES";
export const TOGGLE_FAST_MODE = "TOGGLE_FAST_MODE";
export const TOGGLE_FONT = "TOGGLE_FONT";


const loadObjFromLocal = function (objKey: string) {
  return JSON.parse(localStorage.getItem(objKey)!);
}
const loadStringFromLocal = function (stringKey: string) {
  return localStorage.getItem(stringKey);
}
const saveStringOnLocal = function ({ strKey, str }: { strKey: string, str: string }) {
  localStorage.setItem(strKey, str);
};

const isCustomKeyboard = function (): boolean {
  const msgs: NigmaMessage[] = loadObjFromLocal("messages");
  if (msgs == null || msgs.length === 0) {
    return false;
  }
  const lastMsg = msgs[msgs.length - 1];
  return lastMsg.customKeyboard || (lastMsg.options && lastMsg.options.length > 0) || false;
}

export const store = createStore<State>({
  state: {
    messageHistory: loadObjFromLocal("messages") ? [...loadObjFromLocal("messages")] : [],
    sessionId: loadStringFromLocal("sessionId")!,
    showCustomKeyboard: isCustomKeyboard(),
    composerHeight: 80,
    fastMode: false,
    font: loadStringFromLocal("font") || 'Aquire'
  },
  mutations: {
    [ADD_MESSAGE](state, message: NigmaMessage) {
      state.messageHistory = [...state.messageHistory, message];
    },
    [SEND_MESSAGE_REQ]() {
      // console.log(request);
    },
    [SEND_MESSAGE_RES](state, resMessages) {
      //console.log(resMessages);
      state.messageHistory = [...state.messageHistory, ...resMessages];
    },
    [SEND_MESSAGE_ERR](state, error) {
      console.error(error);
      //
    },
    [CREATE_SESSION_REQ](state, request) {
      console.log(request);
      //
    },
    [CREATE_SESSION_RES](state, sessionId) {
      state.sessionId = sessionId;
    },
    [CREATE_SESSION_ERR](state, error) {
      console.error(error);
      //
    },
    [TOGGLE_CUSTOM_KEYBOARD](state, on) {
      if (on != null) {
        state.showCustomKeyboard = on;
      } else {
        state.showCustomKeyboard = !state.showCustomKeyboard;
      }
    },
    [UPDATE_COMPOSER_HEIGHT](state, height) {
      state.composerHeight = height;
    },
    [RESET_MESSAGES](state) {
      state.messageHistory = [];
    },
    [TOGGLE_FAST_MODE](state, on) {
      if (on != null) {
        state.fastMode = on;
      } else {
        state.fastMode = !state.fastMode;
      }
    },
    [TOGGLE_FONT](state, font) {
      if (font != null) {
        state.font = font;
      } else {
        state.font = state.font === 'Avenir' ? 'Aquire' : 'Avenir';
      }
      saveStringOnLocal({strKey: 'font', str: state.font}); //TODO - trovare un modo migliore per salvere vuex su disco (mutation o action che salvano in automatico)
    }
  },
  actions: {
    async createSession({ commit, state, dispatch }, sessionId?) {
      const req: RequestInit = {
        method: 'POST',
        redirect: 'follow'
      };
      if (sessionId) {
        req.body = JSON.stringify({ sessionId });
      }
      commit(CREATE_SESSION_REQ, req);
      try {
        const res = await (await fetch("https://i9y86y0v1l.execute-api.eu-west-2.amazonaws.com/prod/createSession", req)).json();
        const sessionId = res.sessionId;
        dispatch('saveStringOnLocal', { strKey: "sessionId", str: sessionId });
        commit(CREATE_SESSION_RES, sessionId);
        const resMessages = res.messages.map(
          (msg: NigmaMessage) => (new NigmaMessage({ text: msg.text, sender: 'other', image: msg.image, delay: msg.delay, customKeyboard: msg.customKeyboard, options: msg.options })));
        dispatch('saveObjOnLocal', { objKey: "messages", obj: [...state.messageHistory, ...resMessages] });
        commit(SEND_MESSAGE_RES, resMessages);
      } catch (error) {
        commit(CREATE_SESSION_ERR, error);
      }
    },

    async sendMessage({ commit, state, dispatch }, message) {
      if (state.sessionId === null) {
        throw new Error("sessionId null!");
      }
      commit(ADD_MESSAGE, { text: message, sender: 'me' });
      const req: RequestInit = {
        method: 'POST',
        body: JSON.stringify({
          sessionId: state.sessionId,
          message,
        }),
        redirect: 'follow'
      };
      commit(SEND_MESSAGE_REQ, req);
      try {
        const res = await (await fetch("https://i9y86y0v1l.execute-api.eu-west-2.amazonaws.com/prod/elaborateMessage", req)).json();
        const resMessages = res.messages.map(
          (msg: NigmaMessage) => (new NigmaMessage({ text: msg.text, sender: 'other', image: msg.image, delay: msg.delay, customKeyboard: msg.customKeyboard, options: msg.options })));
        dispatch('saveObjOnLocal', { objKey: "messages", obj: [...state.messageHistory, ...resMessages] });
        commit(SEND_MESSAGE_RES, resMessages);
      } catch (error) {
        commit(SEND_MESSAGE_ERR, error);
      }

    },
    saveObjOnLocal(state, { objKey, obj }) {
      localStorage.setItem(objKey, JSON.stringify(obj));
    },
    saveStringOnLocal(state, { strKey, str }) {
      localStorage.setItem(strKey, str);
    },
    resetSession({ commit, state, dispatch }) {
      commit(RESET_MESSAGES);
      dispatch('saveObjOnLocal', { objKey: 'messages', obj: [] });
      dispatch('createSession', state.sessionId);
    }

  },
  modules: {
  }
})

